import { ItemSpriteIds } from "./ItemSpriteIds";
import ItemType from "./ItemType";

export const ItemTypes = {
    pick: new ItemType('1', 'Pick', false, false, ItemSpriteIds.pick.icon),
    sword: new ItemType('2', 'Sword', false, false, ItemSpriteIds.broadSword.icon)
    // helm?
    // boots/armor/etc?
};